export default __webpack_public_path__ + "static/media/interior_7.22607f1c.jpg";